import React from 'react';

import IconButton from '@mui/material/IconButton';
import InsertDriveFileIcon from '@mui/icons-material/InsertDriveFile';
import BrowserUpdatedIcon from '@mui/icons-material/BrowserUpdated';

import axios from '../../../utils/axiosIntercepter';

import {
    StyledTextBox, StyledDocContainer, StyledActionBox, StyledDateBox, ResponsiveDocs
} from './styles';

export interface IProps {
    attachementId: string;
    attachementName: string;
    structureId: string;
    createdAt?: Date;
}

const Doc: React.FC<IProps> = ({
    attachementId, attachementName, structureId, createdAt
}) => {
    const handleDownloadFile = async () => {
        try {
            const res = await axios({
                method: 'get',
                url: `/api/structures/${structureId}/attachements/${attachementId}?q=download`,
                responseType: 'blob',
                headers: {}
            });
            const url = window.URL.createObjectURL(new Blob([res.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', attachementName || 'file');
            document.body.appendChild(link);
            link.click();
        } catch {
            console.warn('Error downloading');
        }
    };

    return (
        <ResponsiveDocs>
            <StyledDocContainer>
                <StyledTextBox>
                    <InsertDriveFileIcon color="primary" />
                    <strong>
                        <span style={{
                            textOverflow: 'ellipsis',
                            maxWidth: '200px'
                        }}
                        >
                            {attachementName}
                        </span>
                    </strong>
                </StyledTextBox>
                <StyledActionBox>
                    <StyledDateBox sx={{ display: { xs: 'none', md: 'inline-block' }, marginTop: '1em', marginRight: '0.6em' }}>
                        <strong style={{}}>
                            {`${createdAt?.toString().slice(8, 10)}/${createdAt?.toString().slice(5, 7)}/${createdAt?.toString().slice(0, 4)}`}
                        </strong>
                    </StyledDateBox>
                    <IconButton component="label" onClick={handleDownloadFile}>
                        <BrowserUpdatedIcon />
                    </IconButton>

                </StyledActionBox>
            </StyledDocContainer>
        </ResponsiveDocs>
    );
};

export default Doc;
